<template>
  <BrandName :tone="tone" :rotate="rotate" :align="align" :stack="stack" :name2-override="name2Override" v-bind="attrs" />
</template>

<script setup>
import { useAttrs } from 'vue'
import BrandName from './BrandName.vue'

defineOptions({ inheritAttrs: false })

defineProps({
  // tone="primary"    (default) — for light/white backgrounds
  // tone="light"               — for dark/black backgrounds
  // tone="on-primary"          — for red/primary backgrounds
  // tone="hero"                — for dark panel: name1 white, name2 brand red
  tone: {
    type: String,
    default: 'primary'
  },
  rotate: {
    type: Boolean,
    default: false
  },
  align: {
    type: String,
    default: 'left'
  },
  stack: {
    type: Boolean,
    default: false
  },
  // name2Override — replaces COMPANY_NAME_2 with a custom string (disables rotation)
  name2Override: {
    type: String,
    default: null
  }
})

const attrs = useAttrs()
</script>
